export interface SearchItemsProps {
  query : string,
  items : any[],
}

export function searchItems({ query, items }: SearchItemsProps): any[] {
  const q = query.toLowerCase().trim();
  if (!q) return items;

  const keywords = q.split(/\s+/);

  const filtered = items.filter((item) => {
    const searchable = Object.values(item)
      .filter((v) => typeof v === 'string')
      .join(' ')
      .toLowerCase();

    return keywords.every((word) => searchable.includes(word));
  });

  return filtered.sort((a, b) => {
    const aStr = Object.values(a).find((v) => typeof v === 'string') || '';
    const bStr = Object.values(b).find((v) => typeof v === 'string') || '';
    return String(aStr).localeCompare(String(bStr));
  });
}
